'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaShirtsinbulk = function FaShirtsinbulk(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm3 0h34.3v31.1l-17.3 7.5-17-7.5v-31.1z m32.1 29.6v-20.7h-29.9v20.7l14.8 6.6z m0-22.9v-4.5h-29.9v4.5h29.9z m-28.1 6.7v2.5h-0.8v-2.5h0.8z m0 3.3v2.5h-0.8v-2.5h0.8z m0 3.3v2.5h-0.8v-2.5h0.8z m0 3.3v2.5h-0.8v-2.5h0.8z m0 3.3v2.6h-0.8v-2.6h0.8z m0.6 3.2l0.4-0.8 2.3 1.1-0.3 0.7z m3.1 1.3l0.3-0.7 2.3 1-0.3 0.7z m3 1.4l0.3-0.8 2.3 1-0.3 0.8z m3 1.3l0.3-0.8 2.4 1.1-0.4 0.7z m4.1 0.3l2.3-1.1 0.4 0.8-2.4 1z m3-1.4l2.3-1 0.4 0.8-2.4 1z m3-1.3l2.4-1 0.3 0.7-2.3 1z m3.1-1.3l2.3-1.1 0.3 0.8-2.3 1z m-21.1-26.8v0.8h-2.6v-0.8h2.6z m3.6 0v0.8h-2.6v-0.8h2.6z m3.6 0v0.8h-2.6v-0.8h2.6z m3.6 0v0.8h-2.5v-0.8h2.5z m3.6 0v0.8h-2.5v-0.8h2.5z m3.6 0v0.8h-2.5v-0.8h2.5z m3.7 0v0.8h-2.6v-0.8h2.6z m3.5 0v0.8h-2.5v-0.8h2.5z m-27 7.6v1.7h-0.8v-2.5h2.6v0.8h-1.8z m5.4-0.8v0.8h-2.6v-0.8h2.6z m3.6 0v0.8h-2.6v-0.8h2.6z m3.6 0v0.8h-2.5v-0.8h2.5z m3.6 0v0.8h-2.5v-0.8h2.5z m3.6 0v0.8h-2.5v-0.8h2.5z m3.7 0v0.8h-2.6v-0.8h2.6z m2.7 2.5v-1.7h-1.7v-0.8h2.6v2.5h-0.9z m0 3.3v-2.5h0.9v2.5h-0.9z m0 3.3v-2.5h0.9v2.5h-0.9z m0 3.3v-2.5h0.9v2.5h-0.9z m0 3.3v-2.5h0.9v2.5h-0.9z m0 3.4v-2.6h0.9v2.6h-0.9z m-13.2-0.8q-2.9 0-5-2.1t-2-4.9q0-2.9 2-4.9t5-2.1q2.9 0 4.9 2.1t2.1 4.9q0 2.9-2.1 4.9t-4.9 2.1z m-3.7-8.5q0 0.8 0.4 1.2t1.1 0.6 1.5 0.1 1.4 0.1 1.1 0.2 0.4 0.7q0 1.1-2.5 1.1-2.1 0-2.7-1.2h-0.1l-0.7 1.4q1.5 1 3.6 1 0.7 0 1.3-0.1t1.2-0.4 1-0.7 0.4-1.2q0-1-0.6-1.6t-1.5-0.6-1.8 0-1.5-0.2-0.6-0.5q0-0.5 0.5-0.8t0.9-0.3 0.9-0.1q0.8 0 1.6 0.3t1.1 0.7h0.1l0.7-1.3q-0.1 0-0.5-0.1t-0.5-0.2-0.4-0.2-0.5-0.2-0.5-0.1-0.5 0-0.5-0.1q-0.7 0-1.3 0.1t-1.2 0.4-0.9 0.8-0.4 1.2z' })
        )
    );
};

exports.default = FaShirtsinbulk;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/shirtsinbulk.js
// module id = 518
// module chunks = 58411574672382 79611799117203 84521481881339 164655002686464